import React, { Fragment, useState } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { Search } from 'react-feather';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFilters, resetFormData } from 'Services/Features/Admin/adminSlice';
import { getAllAdmin } from 'Services/Features/Admin/Utils/adminUtils';
import Select from 'react-select';
import { Link } from "react-router-dom";

const FindAdmin = () => {
    const dispatch = useDispatch()
    const filters = useSelector(state => state.admin.filters)
    const [selectedSortValue, setSelectedSortValue] = useState(null)

    const options = [
        { value: 'is_super_admin', label: 'Super Admin' },
        { value: 'is_admin', label: 'Admin' },
        { value: 'is_cs', label: 'Customer Service' },
    ];

    const handleAdd = (e) => {
        dispatch(resetFormData());
    };
    
    const handleSelectChangeSort = (selectedOption) => {
        setSelectedSortValue(selectedOption);
        if (selectedOption) {
            const newFilters = {
                ...filters,
                'filter[is_super_admin]': selectedOption.value === 'is_super_admin' ? 1 : 0,
                'filter[is_admin]': selectedOption.value === 'is_admin' ? 1 : 0,
                'filter[is_cs]': selectedOption.value === 'is_cs' ? 1 : 0,
                'page': 1,
            };
            dispatch(setFilters(newFilters));
            dispatch(getAllAdmin(newFilters));
        } else {
            const newFilters = {
                ...filters,
                'filter[is_super_admin]': '',
                'filter[is_admin]': '',
                'filter[is_cs]': '',
                'page': 1,
            };
            dispatch(setFilters(newFilters));
            dispatch(getAllAdmin(newFilters));
        }
    }

    const handleClickSearch = (e) => {
        e.preventDefault()
        const newFilters = {
            ...filters,
            'page': 1,
        };
        dispatch(setFilters(newFilters));
        dispatch(getAllAdmin(newFilters));
    }

    const handleResetFilter = (e) => {
        e.preventDefault()
        dispatch(resetFilters());
        dispatch(getAllAdmin());
        setSelectedSortValue(null);
    }

    return (
        <Fragment>
            <Col xl="12">
                <div className="job-filter">
                    <div className="faq-form">
                        <Col className="d-flex justify-content-end align-items-center px-0" xs="12" sm="12" md="12" lg="12" xl="12">
                            <Row className="w-100">
                                <Col className="d-flex justify-content-start align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="3" style={{ whiteSpace: 'nowrap' }}>
                                    <Link
                                        to={`${process.env.PUBLIC_URL}/admin/add`}
                                        onClick={handleAdd}>
                                        <Button color="primary">
                                            <i className="fa fa-plus-circle fa-lg"></i> Tambah Admin
                                        </Button>
                                    </Link>
                                </Col>
                                <Col className="d-flex justify-content-between align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <div className="position-relative w-100">
                                        <Input className="form-control" type="text" placeholder="Search by name.."
                                            value={filters['filter[name]']}
                                            onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                                            onChange={(e) => {
                                                dispatch(setFilters({
                                                    ...filters,
                                                    'filter[name]': e.target.value
                                                }));
                                            }}
                                        />
                                        <Search className="search-icon position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                                    </div>
                                </Col>
                                <Col className="d-flex justify-content-between align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <div className="position-relative w-100">
                                        <Input className="form-control" type="text" placeholder="Search by email.."
                                            value={filters['filter[email]']}
                                            onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                                            onChange={(e) => {
                                                dispatch(setFilters({
                                                    ...filters,
                                                    'filter[email]': e.target.value
                                                }));
                                            }}
                                        />
                                        <Search className="search-icon position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                                    </div>
                                </Col>
                                <Col className="mb-2" xs="12" sm="12" md="8" lg="8" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <Select
                                        options={options}
                                        className="js-example-basic-single"
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder="Find by role.."
                                        onChange={handleSelectChangeSort}
                                        value={selectedSortValue}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center px-0" xs="12" sm="12" md="4" lg="4" xl="3" style={{ whiteSpace: 'nowrap' }}>
                                    <Button color="warning me-2" onClick={handleResetFilter}>Reset</Button>
                                    <Button color="primary me-2" onClick={handleClickSearch}>Filter</Button>
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </div>
            </Col>
        </Fragment>
    );
};

export default FindAdmin;